import { CSSObject } from '@chakra-ui/react';

export const BoxHeaderWrapper: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDir: 'column',
  color: 'white',
  fontWeight: 'normal',
  height: 'auto',
  border: 'none',
  fontFamily: 'Staatliches',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  textTransform: 'uppercase',

  '& .state-inprogress': {
    color: 'black',
  },
  svg: {
    pt: '1',
    pos: 'relative',
    bottom: '1',
  },
};

export const FlexHeadingMiscWrapper: CSSObject = {
  zIndex: 'overlay',
  fontFamily: 'accent',
  '.chakra-badge.state-inprogress': {
    color: 'black',
  },
  '&&&&': {
    fontSize: 'xs',
    flexDir: ['column', 'row'],
    alignItems: ['flex-start', 'center'],

    '.timestamp': {
      bg: 'alpha.700',
      borderRadius: 'base',
      color: 'gamma.500',
      fontWeight: 'bold',
      p: '1',
      fontSize: '2xs',
      mb: '0.5',
    },
  },
};

export const BoxDot: CSSObject = {
  display: ['none', 'block'],
  bg: 'whiteAlpha.400',
  border: 'none',
};

export const TextSportName: CSSObject = {
  '&&&&': {
    fontSize: 'inherit',
    fontWeight: 'inherit',
    textTransform: 'capitalize',
  },
};

export const TextVS: CSSObject = {
  alignSelf: 'end',
  color: 'white',
};
